import { Component, Input, OnInit } from '@angular/core';
import { Params, Router } from '@angular/router';

import { DetailsHelperService } from '../../services/details-helper.service';
import { isValidUrl, parseEmbeddedUrl } from '../../utilities/generic.util';
import { ColumnDef } from '../reports.constants';

@Component({
  selector: 'app-report-data',
  templateUrl: './report-data.component.html',
  styleUrls: ['./report-data.component.scss']
})
export class ReportDataComponent implements OnInit {

  @Input() content = '';
  @Input() column = '';
  @Input() csvColumnInfo?: ColumnDef;
  @Input() row?: string[];

  contentType: 'text' | 'url' | 'link' | 'urlList';
  currency?: string;

  name: string;
  url: string;
  queryParams?: Params;
  urlList: { before: string; url: string, after?: string, queryParams?: Params }[];

  constructor(
    private router: Router,
    private detailsHelper: DetailsHelperService,
  ) { }

  ngOnInit(): void {

    const urlList = this.getUrlList();

    if (urlList.length) {
      this.urlList = urlList;
      this.contentType = 'urlList';
      return;
    }

    if (isValidUrl(this.content)) {
      const parsed = new URL(this.content);

      this.url = parsed.pathname;

      const queryParams: Params = {};

      parsed.searchParams.forEach((value, key) => {
        queryParams[key] = value;
      })

      this.queryParams = queryParams;

      this.contentType = 'url';
      return;
    }

    const parsed = parseEmbeddedUrl(this.content);

    if (!parsed) {
      this.contentType = 'text';
      return;
    }

    const { before: embeddedName, url: embeddedUrl } = parsed;
    this.name = embeddedName;
    this.url = embeddedUrl;
    this.contentType = 'link';
  }

  getUrlList() {
    return this.content.split(', ')
      .map((segment) => parseEmbeddedUrl(segment))
      .filter(Boolean);
  }

  navigate(url: string, queryParams?: Params) {
    this.router.navigate([ url ], { queryParams });
  }

  openDetails(url: string, _queryParams?: Params) {

    const segments = url.split('/');

    const [ _blank, objectType, objectId ] = segments;

    switch (objectType) {
      case 'user':
        this.detailsHelper.open('users', { id: objectId });
        break;
      case 'job':
      case 'jobs':
        this.detailsHelper.open('job', { id: objectId });
        break;
      default:
        console.warn('Unable to open details for object type: ', objectType);
    }
  }

}
